// extracted by mini-css-extract-plugin
export default {"fab":"income_fab__B4dnw","filter":"income_filter__GJoDI","transaction":"income_transaction__178GR","sliderContainer":"income_sliderContainer__-1uFP"};